import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EmployeeItemPreview } from './../../interfaces/employee.model';

import { environment } from '@unico-people/ongoing-dashboard/enviroment';
import { SessionStorage } from '@unico-people/shared/utils/storage';

export interface List {
  page: number;
  pageSize: number;
  sortOrder: string;
}
@Injectable({
  providedIn: 'root'
})
export class ImportService {
  private acc = SessionStorage.getItem('currentAccount');
  private urlOngoing = environment.url;

  constructor(public http: HttpClient) {}

  /**
   * Preview import employees
   * @param data file one to be uploaded
   */
  previewImport(data?: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', data);

    return this.http.post(`${this.urlOngoing}/file-import?account=${this.acc}`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  /**
   * Import employees
   * @param data list with employees imported
   */
  import(data: Array<EmployeeItemPreview>): Observable<any> {
    return this.http.post<any>(`${this.urlOngoing}/file-import?account=${this.acc}`, data);
  }

  /**
   * Takes requestId from view and returns a .csv file with error logs
   * @param requestId id returned in request of preview
   * @returns an .csv file with logs of errors
   */
  getLogsErros(requestId: string): Observable<any> {
    const httpOptions = {
      responseType: 'blob' as 'json'
    };

    return this.http.get(`${this.urlOngoing}/file-import/errors/${requestId}?account=${this.acc}`, httpOptions);
  }

  /**
   * @param params
   * @returns list of import processes
   */
   getListStatusProcessingImport(params: any): Observable<any> {
    const { page, pageSize, sortOrder} = params
    return this.http.get<any>(
      `${this.urlOngoing}/file-import?account=${this.acc}&page=${page}&pageSize=${pageSize}&sortOrder=${sortOrder}`,
      {
        observe: 'response'
      }
    );
  }

  /**
   *
   * @param protocol
   * @returns import protocol processing status
   */
  getStatusProcessingProtocol(protocol: string): Observable<any> {
    return this.http.get<any>(
      `${this.urlOngoing}/file-import/${protocol}?account=${this.acc}`,
      {
        observe: 'response'
      }
    );
  }

  /**
   * Request that returns url for error file download
   * @param protocol
   * @returns specific protocol error
   */
  getErrorProtocol(protocol: string): Observable<any> {
    return this.http.get<any>(
      `${this.urlOngoing}/file-import/${protocol}/error-file-url?account=${this.acc}`,
      {
        observe: 'response'
      }
    );
  }
}
